export const About = () => {
  return (
    <section
      id="about"
      className="lg:pt-[3em] md:pt-[8em] pt-[12em] max-w-prose scroll-mt-24"
    >
      <p className="leading-relaxed">
        I’m a software developer with experience in full-stack web development.
        While my background leans more toward front-end development, I enjoy
        delivering clean, simplicity, reliability, and consistency across all
        stages of the software lifecycle.
        <br></br>
        <br></br>
        In the past, I’ve had the opportunity to work with a variety of large
        corporations and outsourcing partners across industries such as
        healthcare, communications, and learning aid software.
        <br />
        <br />
        In my spare time, I enjoy surfing, snowboarding, playing the guitar,
        hiking, and traveling with my wife.
      </p>
    </section>
  );
};
